






























































































































































































































import { Vue, Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

type Group = I.AxZone;
type Item = I.MealReaderDetail;

type GroupListPanel = I.AxGroupListPanel<Group, Item>;
type PageInfo = I.MealSettingPageInfo;

type Store = I.MealTimeData & { time?: string };
type DataItem = U.DataItem<Store, State>;
type DataStore = U.DataStore<Store>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  zoneCode: number;
  zoneName: string;
  doorID: number;

  doorName: string;
  cornerID: number;
  cornerName: string;

  itemStatus: E.ItemStatus;

  constructor() {
    this.zoneCode = '' as never;
    this.zoneName = '' as never;
    this.doorID = '' as never;

    this.doorName = '' as never;
    this.cornerID = '' as never;
    this.cornerName = '' as never;

    this.itemStatus = E.ItemStatus.None;
  }
}

class DialogState {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: unknown[];
  headers: unknown[];
  items: unknown[];
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.callback = async () => {};
  }
}

interface EditDialogTimeProps {
  time: string;
  initTime: string;
  latestTime: string;

  canceled: boolean;
  saved: boolean;
  valid: boolean;
}

interface EditDialogPriceProps {
  mealPrice: string;
  initPrice: string;
  latestPrice: string;

  canceled: boolean;
  saved: boolean;
  valid: boolean;
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  panel!: GroupListPanel;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
  dialogState!: DialogState;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.meal.configGet();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async updateItem(item: UpdateItemParam) {
    const result = await this.API.call.meal.mealTimeUpdate(item);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
      //this.CodeUpdated(result.data, item.updateFlag);
    }
  }
}

@Component
class DataItemHandler extends Vue {
  dataItems: DataItem[] = [
    {
      name: '데이터 테이블',
      store: new DataStore<Store>({
        headers: {
          mealCode: '코드',
          mealName: '유형',
          time: '시간',
          mealPrice: '가격',
          mealUseBool: '사용'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class GroupPanelHandler extends BaseClass {
  openDoorSelectDialog!: Function;

  onListGroupChanged(group?: Group) {
    if (!this.pageInfo || !group) return;

    if (this.panel.items) {
      this.panel.items = this.pageInfo.listMealReader.filter(x => x.zoneCode === group.code);
    }
  }

  onListItemChanged(item?: Item) {
    if (item) {
      this.dataItem.state.zoneCode = item.zoneCode;
      this.dataItem.state.zoneName = item.zoneName;
      this.dataItem.state.doorID = item.doorID;
      this.dataItem.state.doorName = item.doorName;
      this.dataItem.state.cornerID = item.cornerID;
      this.dataItem.state.cornerName = item.cornerName;
      this.dataItem.store.setItems(item.listMealTime);

      this.dataItem.state.itemStatus = E.ItemStatus.Update;
    }
  }

  onListAddClicked(group: Group) {
    this.dataItem.state = new State();
    this.dataItem.state.zoneCode = group.code;
    this.dataItem.state.zoneName = group.name;

    const mealCornerItems = this.pageInfo.listMealCorner.filter(
      x => x.zoneCode === this.panel.group
    );

    if (mealCornerItems.length > 0) {
      this.dataItem.state.cornerID = mealCornerItems[0].cornerID;
      this.dataItem.state.cornerName = mealCornerItems[0].cornerName;
    }

    const listMealTime: Store[] = [];
    this.pageInfo.listMealCode.forEach(item => {
      listMealTime.push({
        doorID: 0,
        mealCode: Number.parseInt(item.code),
        mealName: item.name,
        time: '00:00~00:00',
        mealFromTime: '0000',
        mealToTime: '0000',
        mealPrice: 0,
        mealUse: 0,
        mealUseBool: false
      });
    });
    this.dataItem.store.setItems(listMealTime);
    this.dataItem.state.itemStatus = E.ItemStatus.New;
    Vue.set(this.dataItem.state, 'id', '자동 생성');
    this.openDoorSelectDialog();
  }
}

@Component
class SelectDialogHandler extends BaseClass {
  private ignoreWatch = 0;

  private timeRules = (v: string) =>
    /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])~(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/.test(v);

  private priceRules = (v: string) => /^[0-9]+$/.test(v);

  openDoorSelectDialog() {
    const title = '식수 리더기 선택';
    const headers = [{ text: '이름', value: 'name', align: 'start' }];

    // 현재 선택된 구역 코드만 나오도록 함. 그리고 현재 등록된 식수 리더기는 안보이게 한다
    const currentReaders = this.panel.items.map(x => x.doorID);
    const items = this.pageInfo.listDoor
      .filter(x => x.zoneCode === this.dataItem.state.zoneCode)
      .filter(x => currentReaders.findIndex(readers => readers === x.code) === -1);

    const selected = [] as I.CodeData[];

    const callback = async () => {
      const selected = this.dialogState.selected as I.DoorData[];
      if (selected.length > 0) {
        const door = selected[0];
        this.dataItem.state.doorID = door.code;
        this.dataItem.state.doorName = door.name;
      } else {
        this.dataItem.state.doorID = '' as never;
        this.dataItem.state.doorName = '' as never;
      }
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openSelectDialog(
    title: string,
    headers: unknown[],
    items: unknown[],
    selected: unknown[],
    callback: () => Promise<void>
  ) {
    this.dialogState.show = true;
    this.dialogState.title = title;
    this.dialogState.headers = headers as never;
    this.dialogState.items = items as never;
    this.dialogState.selected = selected as never;
    this.dialogState.callback = callback;
  }

  async closeDialog() {
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 닫을 때 식수 리더기가 선택이 안되었을때의 처리
    if ((this.dataItem.state.doorID as never) === '') {
      this.dataItem.state = new State();
      this.dataItem.store.setItems([]);
    }

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
    }, 100);
  }

  onDialogChanged() {
    this.dialogState.callback();
  }

  onDialogRowClicked(item: never) {
    this.dialogState.selected = [item];
  }

  onEditTimeDialogSave(x: EditDialogTimeProps) {
    x.saved = true;
    x.valid = this.timeRules(x.time);
  }
  onEditTimeDialogCancel(x: EditDialogTimeProps) {
    x.canceled = true;
  }
  onEditTimeDialogOpen(x: EditDialogTimeProps) {
    x.initTime = x.time;
    x.latestTime = x.time;
  }
  onEditTimeDialogClose(x: EditDialogTimeProps) {
    if (!x.valid || x.canceled) {
      x.time = x.initTime;
      x.canceled = false;
      return;
    }

    if (x.saved) {
      x.time = x.latestTime;
      return;
    }
  }
  onInputTime(x: EditDialogTimeProps) {
    x.valid = this.timeRules(x.time);
    x.latestTime = x.time;
  }

  onEditPriceDialogSave(x: EditDialogPriceProps) {
    x.saved = true;
    x.valid = this.priceRules(x.mealPrice);
  }
  onEditPriceDialogCancel(x: EditDialogPriceProps) {
    x.canceled = true;
  }
  onEditPriceDialogOpen(x: EditDialogPriceProps) {
    x.initPrice = x.mealPrice;
    x.latestPrice = x.mealPrice;
  }
  onEditPriceDialogClose(x: EditDialogPriceProps) {
    if (!x.valid || x.canceled) {
      x.mealPrice = x.initPrice;
      x.canceled = false;
      return;
    }

    if (x.saved) {
      x.mealPrice = Number.parseInt(x.latestPrice).toString();
      return;
    }
  }
  onInputPrice(x: EditDialogPriceProps) {
    x.valid = this.priceRules(x.mealPrice);
    x.latestPrice = x.mealPrice;
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;
  dialogState = new DialogState();

  panel: GroupListPanel = {
    groups: [],
    items: [],
    group: -1,
    item: -1
  };

  pageInfo = {} as PageInfo;

  get mealCornerItems() {
    if (!this.pageInfo.listMealCorner) return [];
    return this.pageInfo.listMealCorner.filter(x => x.zoneCode === this.dataItem.state.zoneCode);
  }
}

const Handlers = Mixins(ApiHandler, DataItemHandler, GroupPanelHandler, SelectDialogHandler);

@Component
export default class AxMealTimeSettingDialog extends Mixins(BaseData, Handlers, AxPage) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.setupPageInfo(pageInfo);

      this.pageInfo = pageInfo;
      this.panel.groups = this.getZoneList();
    }
  }

  setupPageInfo(pageInfo: PageInfo) {
    pageInfo.listMealReader.forEach(mealReader => {
      mealReader.listMealTime = (mealReader.listMealTime as Store[]).map(x => {
        const hourStart = x.mealFromTime.substr(0, 2);
        const minStart = x.mealFromTime.substr(2, 2);
        const startTime = hourStart + ':' + minStart;

        const hourEnd = x.mealToTime.substr(0, 2);
        const minEnd = x.mealToTime.substr(2, 2);
        const endTime = hourEnd + ':' + minEnd;

        const time = startTime + '~' + endTime;
        if (x.mealUse === 1) {
          x.mealUseBool = true;
        }
        x.time = time;
        return x;
      });
    });
  }

  async onSaveClicked() {
    const {
      zoneCode,
      zoneName,
      doorID,
      doorName,
      cornerID,
      cornerName,
      itemStatus
    } = this.dataItem.state;

    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag =
      itemStatus === E.ItemStatus.New ? E.EUpdateFlag.Insert : E.EUpdateFlag.Update;

    if (((this.dataItem.state.doorID as unknown) as string) === '') {
      await this.showErrorModal('오류', '리더기를 선택 해주세요.');
      return;
    } else if (this.dataItem.state.doorName === '') {
      await this.showErrorModal('오류', '리더기명을 입력 해주세요.');
      return;
    }

    const title = '확인';
    const message =
      itemStatus === E.ItemStatus.New
        ? '입력한 아이템을 추가할까요?'
        : '선택한 아이템을 수정할까요?';
    const buttons = ['네', '아니오'];

    const confirm = await this.showConfirmModal(title, message, buttons);
    if (confirm !== 0) return;

    const listMealTime = this.dataItem.store.items.map(x => {
      if (!x.time) {
        x.time = '00:00~00:00';
      }
      const split = x.time.replace(/:/g, '').split('~');

      // split[0] = 1200
      // split[1] = 1300
      // split[2] = 1200~1300
      x.mealFromTime = split[0];
      x.mealToTime = split[1];
      if (x.mealUseBool === true) {
        x.mealUse = 1;
      }
      // 12:00~13:00 --> 1200~1300
      return x;
    });

    this.setLoading(true);

    const result = await this.updateItem({
      zoneCode,
      zoneName,
      doorID,
      doorName,
      cornerID,
      cornerName,
      updateFlag,
      listMealTime
    });

    this.setLoading(false);
    if (!result) return;

    this.onUpdated(updateFlag);
  }

  async onDeleteClicked() {
    const {
      zoneCode,
      zoneName,
      doorID,
      doorName,
      cornerID,
      cornerName,
      itemStatus
    } = this.dataItem.state;

    if (itemStatus === E.ItemStatus.None) return;

    const confirm = await this.showConfirmModal('확인', '선택된 아이템을 삭제할까요?', [
      '네',
      '아니오'
    ]);
    if (confirm !== 0) return;

    this.setLoading(true);

    const updateFlag = E.EUpdateFlag.Delete;
    const listMealTime = this.dataItem.store.items;

    const result = await this.updateItem({
      zoneCode,
      zoneName,
      doorID,
      doorName,
      cornerID,
      cornerName,
      updateFlag,
      listMealTime
    });

    this.setLoading(false);
    if (!result) return;
    this.onUpdated(updateFlag);
  }

  async onUpdated(updateFlag: E.EUpdateFlag) {
    if (!this.pageInfo) return;
    const prevGroup = this.panel.group;

    this.panel.groups = [];
    this.panel.items = [];

    await this.prepare();

    // this.panel.items = this.pageInfo.listCode.filter(
    //   x => x.dataType === ((this.panel.group as unknown) as string)
    // );

    this.panel.group = prevGroup;
    await this.$nextTick();

    if (updateFlag !== E.EUpdateFlag.Delete) {
      // this.panel.item = this.panel.items.findIndex(x => x.code === result.code);
    }

    if (updateFlag === E.EUpdateFlag.Insert) {
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      await this.showErrorModal('알림', '추가되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Update) {
      await this.showErrorModal('알림', '수정되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Delete) {
      this.dataItem.state = new State();
      this.dataItem.store.setItems([]);
      this.panel.item = -1;
      await this.showErrorModal('알림', '삭제되었습니다');
    }
  }
  // v-dialog Start
  on = true;

  state = new State();

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Prop({ type: String, default: '1200px' })
  width!: string;

  @Prop({ type: String, default: '700px' })
  height!: string;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  // v-dialog End
}
